// ── Centralized API utility for TaxVault Global ───────────────────────────
// All API calls go through this file — change REACT_APP_API_URL in .env to switch environments

export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * Authenticated fetch helper
 * @param {string} endpoint  - e.g. "/api/documents/"
 * @param {object} options   - standard fetch options
 * @param {string} token     - JWT token from AuthContext
 */
export async function apiFetch(endpoint, options = {}, token = null) {
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    let errMsg = `Request failed: ${res.status}`;
    try {
      const err = await res.json();
      errMsg = err.detail || err.message || errMsg;
    } catch (_) {}
    throw new Error(errMsg);
  }

  // 204 No Content
  if (res.status === 204) return null;

  return res.json();
}

/** Multipart form upload (no Content-Type header — browser sets boundary) */
export async function apiUpload(endpoint, formData, token = null) {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: "POST",
    headers,
    body: formData,
  });

  if (!res.ok) {
    let errMsg = `Upload failed: ${res.status}`;
    try {
      const err = await res.json();
      errMsg = err.detail || err.message || errMsg;
    } catch (_) {}
    throw new Error(errMsg);
  }

  return res.json();
}
